'use strict';

const Reference = require('./Reference');

module.exports = class RequestReference extends Reference {
  constructor (request, requestArgs, optional = false) {
    super();
    this.request = request;
    this.requestArgs = requestArgs;
    this.optional = optional;
  }

  get typeName () {
    return this.request.type.typeName;
  }

  get requestName () {
    return this.request.name;
  }

  get requestKey () {
    return this.request.keyFor(...this.requestArgs);
  }

  storagePath (...additonalPaths) {
    return [this.typeName, 'REQUESTS', this.requestKey, ...additonalPaths];
  }

  asOptional () {
    return new RequestReference(this.request, this.requestArgs, true);
  }

  toString () {
    return this.requestKey;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/RequestReference.js